import classNames from 'classnames';
import React from 'react';
import { IChoiceInputProps } from '../input';
export interface IRadio extends IChoiceInputProps {
	id?: string;
	defaultValue?: string;
	checked?: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onClick?: () => void;
	onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
	isHover?: boolean;
}

const Radio = React.forwardRef<HTMLInputElement, IRadio>(
	(
		{
			id,
			defaultValue,
			name,
			checked,
			value,
			disabled,
			onChange,
			onFocus,
			onClick,
			isHover,
		},
		ref
	) => {
		return (
			<input
				id={id}
				type="radio"
				defaultValue={defaultValue}
				ref={ref}
				name={name}
				checked={checked}
				value={value}
				disabled={disabled}
				onClick={onClick}
				onChange={onChange}
				onFocus={(event: React.FocusEvent<HTMLInputElement>) => {
					if (onFocus) {
						onFocus(event);
					}
				}}
				className={classNames(
					'flex-none w-6 h-6 appearance-none rounded-full border-2 before:block before:w-3/5 before:h-3/5 before:rounded-full before:my-1 before:mx-auto checked:border-brand checked:before:bg-brand',
					{ 'border-font': !isHover && !disabled,
					'border-brand': isHover && !disabled }
				)}
			/>
		);
	}
);

export default Radio;
